import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProfilePicture {

  constructor(){}

  generate(firstName: any, lastName: any): string{
    if (!firstName) {
      firstName = 'A';
    }
    if (!lastName) {
      lastName = 'A';
    }
    const initials = firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
    // tslint:disable-next-line: no-bitwise

    let randomColor = {background: '#000000', color: '#ffffff'};
    const colorArry = [
      // {background: '#F8F3FE', color: '#A466F4'},
      // {background: '#FEF8F3', color: '#F4A266'},
      // {background: '#F0F6E6', color: '#5BAA15'},
      // {background: '#EDF2FE', color: '#6E92F2'},
      {background: '#E95B51', color: '#ffffff'},
      {background: '#EEA240', color: '#ffffff'},
      {background: '#ED9FB2', color: '#ffffff'},
      {background: '#A1E3A3', color: '#ffffff'},
      {background: '#BAAAF5', color: '#ffffff'},
      {background: '#B0D8F2', color: '#ffffff'},
      {background: '#FAD86D', color: '#ffffff'},
      {background: '#B0B0B9', color: '#ffffff'},
    ];

    if (firstName && lastName) {
        const charAscii = firstName.charCodeAt(0);
        const charAscii2 = lastName.charCodeAt(0);
        randomColor = colorArry[(charAscii + charAscii2) % 7];
    } else {
        randomColor = colorArry[0]; // Default color if names are not provided
    }

    // Create a rectangular canvas which will become th image.
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.width = canvas.height = 64;
    if (context){
      // Draw the circle in the background using the randomColor.
      context.fillStyle = randomColor.background;
      context.beginPath();
      context.ellipse(
        canvas.width / 2, canvas.height / 2, // Center x and y.
        canvas.width / 2, canvas.height / 2, // Horizontal and vertical "radius".
        0, // Rotation, useless for perfect circle.
        0, Math.PI * 2 // from and to angle: Full circle in radians.
      );
      context.fill();

      context.font = ((canvas.height * 2) / 5) + 'px sans-serif';
      context.fillStyle = randomColor.color;
      // Make the text's center overlap the image's center.
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillText(initials, canvas.width / 2, (canvas.height + 4) / 2);
    }

    return canvas.toDataURL();
  }
}
